import React from 'react'
import { useState } from 'react'
import { useParams } from 'react-router'
import WorkDetails from '../utils/WorkDetails'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import '@splidejs/splide/dist/css/splide.min.css'
import { motion } from "framer-motion";

export default function DetailsWork() {

  const {id} = useParams()
  const [workDetails, setDetails] = useState(WorkDetails.find(work=>{ return work.id == id }))
  const [imgDetail, setImgDetail] = useState('')

  return (
    <motion.div 
      className='details-work'
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
        <div className="details">
            <div className="one">
                <h1>{workDetails.name}</h1>
                <ul>
                  <li><span>|| Theme ||</span> <p>{workDetails.description.theme}</p></li>
                  <li><span>|| Traget ||</span> <p>{workDetails.description.target}</p></li>
                  <li><span>|| Technologie ||</span> <p>{workDetails.description.techno}</p></li>
                  <li><span>|| Duration ||</span>  <p>{workDetails.description.duration}</p></li>
                </ul>
            </div>
            <img src={workDetails.img} alt="" />
        </div>
        <div className="screen">
          <Splide
              options={{
              perPage : 3,
              type : 'loop',
              arrows : true,
              pagination : false,
              drage : "free",
              gap : "1em",
              width: '96%',
              breakpoints: {
                1200: {
                  perPage: 2,
                 
                },
                850: {
                  perPage: 1,
            
                },
              },
              }}
          >
              {
                workDetails.screenShots.map(screen=>{
                    return <SplideSlide>
                              <img src={screen} onClick={()=>{ setImgDetail(screen) }} />
                            </SplideSlide>
                })
              }
            </Splide>
        </div>

        <div className={imgDetail ? "img-detail img-detail-open" : "img-detail"}>
            <img src={imgDetail}/>
            <button onClick={()=>{ setImgDetail('') }}>
                <span class="material-symbols-outlined">close</span>
            </button>
        </div>

        <div className="bg_open" style={{visibility : imgDetail == '' ? "hidden" : "visible"}}></div>

    </motion.div>
  )
}
